<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="700px" persistent>
    <v-card v-if="!loading">
      <v-card-title class="success white--text">
        <v-icon left color="white">mdi-check-circle</v-icon>
        Conferma Rinnovo
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pt-6">
        <!-- Info Scadenza -->
        <v-alert type="info" dense text class="mb-4">
          <div class="d-flex align-center">
            <v-icon :color="scadenza.tipologiaScadenza ? scadenza.tipologiaScadenza.coloreHex : '#000'" class="mr-3">
              {{ scadenza.tipologiaScadenza ? scadenza.tipologiaScadenza.iconaMaterial : '' }}
            </v-icon>
            <div>
              <div class="font-weight-bold">{{ scadenza.titolo }}</div>
              <div class="text-caption">{{ scadenza.tipologiaScadenza ? scadenza.tipologiaScadenza.nome : '' }}</div>
            </div>
          </div>
        </v-alert>

        <!-- Dati Rinnovo Corrente -->
        <div class="mb-4">
          <div class="text-subtitle-2 mb-2 grey--text text--darken-2">Rinnovo Corrente</div>
          <v-simple-table dense>
            <tbody>
              <tr>
                <td class="grey lighten-4"><strong>Data Scadenza</strong></td>
                <td>{{ rinnovoCorrente.dataScadenza | formatDate }}</td>
              </tr>
              <tr>
                <td class="grey lighten-4"><strong>Importo Previsto</strong></td>
                <td>{{ rinnovoCorrente.importoPrevisto | formatCurrency }}</td>
              </tr>
              <tr v-if="rinnovoCorrente.qta">
                <td class="grey lighten-4"><strong>Quantità</strong></td>
                <td>{{ rinnovoCorrente.qta }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>

        <v-divider class="mb-4"></v-divider>

        <!-- Form Conferma -->
        <v-form ref="form" v-model="valid">
          <v-row>
            <!-- Data Pagamento -->
            <v-col cols="12" md="6">
              <v-menu ref="menuDataPagamento" v-model="menuDataPagamento" :close-on-content-click="false"
                transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="form.dataPagamento" label="Data Pagamento *" prepend-icon="mdi-calendar"
                    readonly v-bind="attrs" v-on="on" outlined dense :rules="[rules.required]"></v-text-field>
                </template>
                <v-date-picker v-model="form.dataPagamento" @input="menuDataPagamento = false"
                  locale="it"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Importo Pagato -->
            <v-col cols="12" md="6">
              <v-text-field v-model.number="form.importoPagato" label="Importo Pagato *" prepend-icon="mdi-currency-eur"
                type="number" step="0.01" min="0" outlined dense
                :rules="[rules.required, rules.positiveNumber]"></v-text-field>
            </v-col>

            <!-- Quantità -->
            <v-col cols="12" md="6">
              <v-text-field v-model.number="form.qta" label="Quantità" prepend-icon="mdi-counter" type="number" min="1"
                outlined dense></v-text-field>
            </v-col>

            <!-- Note -->
            <v-col cols="12">
              <v-textarea v-model="form.note" label="Note" prepend-icon="mdi-note-text" outlined dense rows="2"
                auto-grow></v-textarea>
            </v-col>
          </v-row>
        </v-form>

        <!-- Rinnovo Futuro -->
        <template v-if="scadenza.ricorrenzaMesi">
          <v-divider class="my-4"></v-divider>

          <div class="text-subtitle-2 mb-3 grey--text text--darken-2">
            <v-icon small class="mr-1">mdi-calendar-refresh</v-icon>
            Prossimo Rinnovo
          </div>

          <v-row>
            <!-- Nuova Data Scadenza -->
            <v-col cols="12" md="6">
              <v-menu ref="menuNuovaData" v-model="menuNuovaData" :close-on-content-click="false"
                transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="form.nuovaDataScadenza" label="Nuova Data Scadenza *"
                    prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense
                    :rules="[rules.required]"></v-text-field>
                </template>
                <v-date-picker v-model="form.nuovaDataScadenza" @input="menuNuovaData = false"
                  locale="it"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Nuovo Importo Previsto -->
            <v-col cols="12" md="6">
              <v-text-field v-model.number="form.nuovoImportoPrevisto" label="Nuovo Importo Previsto *"
                prepend-icon="mdi-currency-eur" type="number" step="0.01" min="0" outlined dense
                :rules="[rules.required, rules.positiveNumber]"></v-text-field>
            </v-col>

            <!-- Nuova Quantità -->
            <v-col cols="12" md="6">
              <v-text-field v-model.number="form.nuovaQta" label="Quantità" prepend-icon="mdi-counter" type="number"
                min="1" outlined dense></v-text-field>
            </v-col>

            <!-- Automatico -->
            <v-col cols="12" md="6">
              <v-checkbox v-model="form.nuovoAutomatico" label="Rinnovo automatico" dense hide-details
                class="mt-2"></v-checkbox>
            </v-col>
          </v-row>
        </template>

        <!-- Warning no ricorrenza -->
        <v-alert v-else type="warning" dense text class="mt-4">
          <v-icon left>mdi-alert</v-icon>
          Questa scadenza non ha una ricorrenza impostata. Dopo la conferma non verrà creato un nuovo rinnovo
          automatico.
        </v-alert>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="annulla">
          Annulla
        </v-btn>
        <v-btn color="success" :loading="saving" :disabled="!valid" @click="conferma">
          <v-icon left>mdi-check</v-icon>
          Conferma Rinnovo
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Loading -->
    <v-card v-else>
      <v-card-text class="text-center py-12">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        <div class="mt-4 text-subtitle-1">Caricamento...</div>
      </v-card-text>
    </v-card>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Chiudi
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import {
  getScadenzaById,
  getRinnovoAttivo,
  confermaRinnovo
} from '@/api/api.scadenze.js';

export default {
  name: 'ConfermaRinnovoDialog',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    idScadenza: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      saving: false,
      valid: false,

      scadenza: {},
      rinnovoCorrente: {},

      menuDataPagamento: false,
      menuNuovaData: false,

      form: {
        dataPagamento: this.getToday(),
        importoPagato: 0,
        qta: null,
        note: '',
        nuovaDataScadenza: null,
        nuovoImportoPrevisto: 0,
        nuovaQta: 1,
        nuovoAutomatico: false
      },

      snackbar: {
        show: false,
        text: '',
        color: 'success'
      },

      rules: {
        required: v => !!v || 'Campo obbligatorio',
        positiveNumber: v => v > 0 || 'Deve essere maggiore di 0'
      }
    };
  },

  watch: {
    value(val) {
      if (val && this.idScadenza) {
        this.caricaDati();
      }
    }
  },

  methods: {
    async caricaDati() {
      this.loading = true;
      try {
        // Carica scadenza
        const scadenzaResponse = await getScadenzaById(this.idScadenza);
        this.scadenza = scadenzaResponse.data.data || scadenzaResponse.data;

        // Carica rinnovo attivo
        const rinnovoResponse = await getRinnovoAttivo(this.idScadenza);
        this.rinnovoCorrente = rinnovoResponse.data.data || rinnovoResponse.data;

        // Inizializza form con dati correnti
        this.form.importoPagato = this.rinnovoCorrente.importoPrevisto || 0;
        this.form.qta = this.rinnovoCorrente.qta;

        // Calcola prossima data scadenza se c'è ricorrenza
        if (this.scadenza.ricorrenzaMesi) {
          const dataCorrente = new Date(this.rinnovoCorrente.dataScadenza);
          const prossimaData = new Date(dataCorrente);
          prossimaData.setMonth(prossimaData.getMonth() + this.scadenza.ricorrenzaMesi);

          this.form.nuovaDataScadenza = this.formatDateForPicker(prossimaData);
          this.form.nuovoImportoPrevisto = this.rinnovoCorrente.importoPrevisto || 0;
          this.form.nuovaQta = this.rinnovoCorrente.qta || 1;
        }

      } catch (error) {
        this.mostraErrore('Errore nel caricamento dei dati');
        console.error(error);
        this.$emit('input', false);
      } finally {
        this.loading = false;
      }
    },

    async conferma() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      try {
        const payload = {
          idScadenza: this.idScadenza,
          dataPagamento: this.form.dataPagamento,
          importoPagato: this.form.importoPagato,
          note: this.form.note,
          qta: this.form.qta,
          nuovaDataScadenza: this.form.nuovaDataScadenza,
          nuovoImportoPrevisto: this.form.nuovoImportoPrevisto,
          nuovoAutomatico: this.form.nuovoAutomatico,
          nuovaQta: this.form.nuovaQta
        };

        await confermaRinnovo(payload);

        this.mostraSuccesso('Rinnovo confermato con successo');
        this.$emit('confermato', {
          idScadenza: this.idScadenza,
          ...payload
        });
        this.$emit('input', false);
        this.resetForm();
      } catch (error) {
        this.mostraErrore('Errore nella conferma del rinnovo');
        console.error(error);
      } finally {
        this.saving = false;
      }
    },

    annulla() {
      this.$emit('input', false);
      this.resetForm();
    },

    resetForm() {
      this.form = {
        dataPagamento: this.getToday(),
        importoPagato: 0,
        qta: null,
        note: '',
        nuovaDataScadenza: null,
        nuovoImportoPrevisto: 0,
        nuovaQta: 1,
        nuovoAutomatico: false
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    getToday() {
      return new Date().toISOString().split('T')[0];
    },

    formatDateForPicker(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    mostraSuccesso(text) {
      this.snackbar = { show: true, text, color: 'success' };
    },

    mostraErrore(text) {
      this.snackbar = { show: true, text, color: 'error' };
    }
  },

  filters: {
    formatDate(value) {
      if (!value) return '-';
      const date = new Date(value);
      return date.toLocaleDateString('it-IT');
    },
    formatCurrency(value) {
      if (!value && value !== 0) return '-';
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR'
      }).format(value);
    }
  }
};
</script>
